import Box from '@mui/material/Box';

import { PaletteModeEnum } from '@e-socna/data-layer';

import { ThemeContextProvider } from '../../../../contexts/ThemeContext';

import { Welcome } from '../../Welcome';
import { ContentLockNotice } from '../../ContentLockNotice';
import { useDocumentEditorContext } from '../../contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';
import type { Editable } from '../../types/editable.type';

import { displaySection } from './Section';

export const EditorTabPanel = () => {
  const { enrichedVirtualRoot } = useDocumentEditorContext<Editable>();

  return !enrichedVirtualRoot.subSections.length ? (
    <Welcome />
  ) : (
    <ThemeContextProvider fixedPalette={PaletteModeEnum.Light}>
      <Box
        sx={{ mt: 4, display: 'flex', flexDirection: 'column', width: '100%' }}
      >
        <ContentLockNotice />
        {displaySection(enrichedVirtualRoot)}
      </Box>
    </ThemeContextProvider>
  );
};
